// extracted by mini-css-extract-plugin
export var contained = "Embed-module--contained--f9c86";
export var content = "Embed-module--content--4603d";
export var embed = "Embed-module--embed--38554";